import React from "react";
import logo from "../../common/media/cc_logo_white.svg";
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import { footerLinks } from "../../common/util/uiConfigs/footerConfiguration";

const Footer = () => {
  return (
    <div className="footerImg-sec">
        <div className="container color-white">
            <div className="footerImg">
                <div className="footer-width">
                    <p style={{fontSize: 12, marginBottom: 13}} className="font-700 mt-0">POWERED BY</p>
                    <div className="d-flex">
                        <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                            <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                        </a>
                        <div className="right">
                            <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                            </a>
                            <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                            </a>
                            <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                            </a>
                        </div>
                    </div>
                    <hr className="footer-hr"/>
                    <div className="row links bottom-links">
                        <div className="col">
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                        </div>
                        <div className="col">
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                            <div className="mb-25"><a className="color-white medium" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                        </div>
                        <div className="col">
                            <div className=""><a className="color-white medium" href="mailto:hello+uniqway@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                        </div>
                    </div>  
                </div>  
            </div>
        </div>
    </div>
  )
}

export default Footer;